import { Serializable } from "./Serializable";

export class ServiceTemplateOptions implements Serializable<ServiceTemplateOptions> {

    optionId: number;
    value: string;
    optionName: string;
    optionLabel: string;
    optionType: string;
    unitId: number;
    locked: boolean;
    editable: boolean;

    deserialize(input) {
        input.optionId && (this.optionId = input.optionId);
        input.value && (this.value = input.value);
        input.optionName && (this.optionName = input.optionName);
        input.optionLabel && (this.optionLabel = input.optionLabel);
        input.optionType && (this.optionType = input.optionType);
        input.unitId && (this.unitId = input.unitId);
        this.locked = input.locked;
        this.editable = input.editable;
        return this;
    }

    constructor() {
    }
}
